import React from 'react';
import IntroSection from "../Componentes/HouseDetails2/IntroSection/IntroSection";
import HouseDetails2Gallery from "../Componentes/HouseDetails2/HouseDetails2Gallery/HouseDetails2Gallery";
import HouseDetails2Bottom from "../Componentes/HouseDetails2/HouseDetails2Bottom/HouseDetails2Bottom";

const HouseDetails2 = () => {
	return (
		<>
			<IntroSection />
			<HouseDetails2Gallery />
			<HouseDetails2Bottom />
		</>
	);
};

export default HouseDetails2;